import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useAppSelector } from '../../app/hooks';
import { selectApp } from '../../app/appSlice';
import { SnackBarMessage } from './types';

const Notification = () => {
  const { notification } = useAppSelector(selectApp);
  const [snackPack, setSnackPack] = useState<SnackBarMessage[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [messageInfo, setMessageInfo] = useState<SnackBarMessage | null>(null);

  useEffect(() => {
    setSnackPack((prevState) => {
      if (!notification) return [...prevState];
      return [...prevState, { message: notification.message, type: notification.type, key: new Date().getTime() }];
    });
  }, [notification]);

  useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prevState) => prevState.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(null);
  };

  return (
    <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} TransitionProps={{ onExited: handleExited }}>
      <Alert variant="filled" severity={messageInfo?.type} style={{ whiteSpace: 'pre-line' }}>
        {messageInfo?.message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
